import axios from 'axios'
import store from '@/store'

const BASE_URL = `https://${process.env.VUE_APP_BASE_URL}/api/v1/`
// const BASE_URL = 'http://10.13.123.233:9010/api/v1/'
const TOKEN_TYPE = 'Bearer'
const UNAUTHORIZED = 401

const axiosInstance = axios.create({
  baseURL: BASE_URL,
})

axiosInstance.interceptors.request.use(
  config => {
    const { token } = store.state.user
    const conf = config
    if (token) {
      conf.headers.Authorization = `${TOKEN_TYPE} ${token}`
    }
    return conf
  },
  error => Promise.reject(error),
)

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response
    if (status === UNAUTHORIZED) {
      store.dispatch('setToken', null)
    }
    return Promise.reject(error)
  },
)

export default () => axiosInstance
